import { toast } from "react-toastify";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { useEffect } from "react";
import { _BoardColumnStatuses, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { SelectWorkActivityStatuses } from "../../WorkActivityStatuses/SelectWorkActivityStatuses";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";


interface BoardColumnStatusesCompProps {
    idColumnBoard: number;
}


export const BoardColumnStatuses = ({ idColumnBoard }: BoardColumnStatusesCompProps) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_BoardColumnStatuses)

    const modal = useModal("", MODAL_md);
    const modalC = useModal("Eliminar Tarea", MODAL_SM)

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        let props: any = {
            IDBoardColumn: idColumnBoard
        }
        instance.getBoardColumnStatusesCatalogPorPropiedades(props, null).then(
            (resp) => {
                setLista(resp);
            }
        ).catch(err => { toast.error(err) })
    }

    const create = () => {
        setBean({
            IDBoardColumn: idColumnBoard,
            IsActive: true,
            IsPrimary: false,
            IDEmployee: _single.getAccountID(),
        });
        modal.open("Agregar Relacion");
    }

    const deleteItem = () => {
        instance.deleteBoardColumnStatuses(bean.IDBoardColumnStatuses).then(
            (resp) => {
                getLista();
                modalC.close();
            }
        ).catch(err => { toast.error(err) })
    };

    const editaItem = (obj: any) => {
        instance.updateBoardColumnStatuses(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDBoardColumnStatuses', visible: true },
        { title: 'Columna Relacionada', property: 'IDBoardColumn', visible: false },
        { title: 'Estatus relacionado', property: 'IDWorkActivityStatuses', visible: true },
        { title: 'Esta Activa', property: 'IsActive', visible: true },
        { title: 'Es Primaria', property: 'IsPrimary', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open(`Editar Relacion`); } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />

                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                    <div className="row">
                        <div className="col-md-12">
                            <SelectWorkActivityStatuses label="Estado de Actividad" idSelector={bean.IDWorkActivityStatuses} onChange={(e) => { setBean({ ...bean, IDWorkActivityStatuses: e }) }} />
                        </div>
                        <div className="col-md-12">
                            <label>Posición</label>
                            <input type="number" className="form-control" value={bean.Position} onChange={(e) => {
                                const valor = e.target.value ? Number(e.target.value) : null
                                setBean({ ...bean, Position: valor })
                            }} />
                        </div>

                        <div className="col-md-12">
                            <BasicSwitch estado={bean.IsActive} eventChange={(e) => { setBean({ ...bean, IsActive: e }) }} label="¿Esta Activo?" />
                        </div>
                        <div className="col-md-12">
                            <BasicSwitch estado={bean.IsPrimary} eventChange={(e) => { setBean({ ...bean, IsPrimary: e }) }} label="¿Es Primario?" />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                    <strong>Eliminar item {bean.Name}</strong>
                </ModalConfirm>
            </div>
        </div>
    );
}